export const LocationSVG = (props) => (
  <svg
    height={16}
    viewBox="0 0 16 16"
    width={16}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <filter id="prefix__a" colorInterpolationFilters="auto">
      <feColorMatrix
        in="SourceGraphic"
        values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
      />
    </filter>
    <g
      fill="none"
      fillRule="evenodd"
      filter="url(#prefix__a)"
      transform="translate(-304)"
    >
      <path
        d="M316.839 8a4.839 4.839 0 11-9.678 0 4.839 4.839 0 019.678 0z"
        stroke="#1d1d1b"
      />
      <g stroke="#000" strokeLinecap="round">
        <path d="M312 3.161V.5M312 15.5v-2.661M316.839 8h2.661M304.5 8h2.661" />
      </g>
    </g>
  </svg>
);
